import { Popover } from '@cloudscape-design/components';
import type { ReactNode } from 'react';

/** The `info` slot Cloudscape expects on a Header or KeyValuePairs label: a text-triggered popover. */
export function infoPopover(header: string, content: ReactNode): ReactNode {
  return (
    <Popover header={header} content={content} dismissButton={false} position="top" size="medium" triggerType="text">
      Info
    </Popover>
  );
}
